export const nonZeroString = (v: string) =>
  // +'0' gives 0 hence the test
  (!!v && +v !== 0) ||
  "This field only accept numbers and cannot be 0 or empty.";

export const numbersOnly = (v: string) =>
  /^[\d.]*$/.test(v) || "This field only accept numbers.";

export const nonZeroNumberOnlyRules = [nonZeroString, numbersOnly];
